import moment from "moment";
export const disabledDate = (current: any) => {
  // Allow only dates within the last 100 years
  return (
    current &&
    (current < moment().subtract(100, "years").startOf("day") ||
      current > moment().endOf("day"))
  );
};

// Special doctorId: This doctor can treat patients of any age (under 18 or above).
// All other doctors are restricted to treating only patients above 18.
export const specialDoctorID = "572be7c4-05f4-40c3-9292-5b2523886c28";
// export const specialDoctorID = "8fe96b32-3987-412a-95ed-c92d62f55931";

// 572be7c4-05f4-40c3-9292-5b2523886c28
